import { Switch } from '@/components/ui/switch';

interface NotificationsSectionProps {
  profile: { notifications_enabled?: boolean | null } | null | undefined;
  handleUpdateNotifications: (notificationsEnabled: boolean) => void;
}

export function NotificationsSection({
  profile,
  handleUpdateNotifications,
}: NotificationsSectionProps) {
  return (
    <section className="rounded-xl border border-telekinesis-neutral-800 bg-telekinesis-background-2 p-6">
      <h2 className="mb-5 text-sm font-medium text-telekinesis-neutral-50">
        Notifications
      </h2>

      <div className="flex items-start justify-between gap-4">
        <div className="min-w-0 flex-1">
          <div className="text-sm text-telekinesis-neutral-50">
            Responses
          </div>
          <div className="mt-0.5 text-xs leading-relaxed text-telekinesis-neutral-200">
            Get notified when Telekinesis finishes a long-running request.
          </div>
        </div>
        <Switch
          className="mt-0.5"
          checked={profile?.notifications_enabled ?? false}
          onCheckedChange={handleUpdateNotifications}
        />
      </div>
    </section>
  );
}
